import { 
    AN_OBJECT_SUB_SECTION_GET_REQUEST, AN_OBJECT_SUB_SECTION_GET_SUCCESS, AN_OBJECT_SUB_SECTION_GET_ERROR, 
    AN_OBJECT_SUB_SECTION_GET_BY_KEY_REQUEST, AN_OBJECT_SUB_SECTION_GET_BY_KEY_SUCCESS, AN_OBJECT_SUB_SECTION_GET_BY_KEY_ERROR, 
    AN_OBJECT_SUB_SECTION_ADD_REQUEST, AN_OBJECT_SUB_SECTION_ADD_SUCCESS, AN_OBJECT_SUB_SECTION_ADD_ERROR, 
    AN_OBJECT_SUB_SECTION_EDIT_REQUEST, AN_OBJECT_SUB_SECTION_EDIT_SUCCESS, AN_OBJECT_SUB_SECTION_EDIT_ERROR, 
    AN_OBJECT_SUB_SECTION_DELETE_REQUEST, AN_OBJECT_SUB_SECTION_DELETE_SUCCESS, AN_OBJECT_SUB_SECTION_DELETE_ERROR
} from "../constants/anObjectSubSectionConstants";

const initialState = {
    anObjectSubSections: [],
    anObjectSubSection: {},
    loading: false,
    success: null,
    error: null,
    anObjectSubSectionRequestedCount: 0,
};

export const anObjectSubSectionReducer = (state = initialState, action) => {
    switch (action.type)     {
        case AN_OBJECT_SUB_SECTION_GET_REQUEST:
            return {
                ...state,
                anObjectSubSectionRequestedCount: ++state.anObjectSubSectionRequestedCount,
                loading: true,
            };
        case AN_OBJECT_SUB_SECTION_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                anObjectSubSections: action.payload,
                success: true,
            };
        case AN_OBJECT_SUB_SECTION_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case AN_OBJECT_SUB_SECTION_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case AN_OBJECT_SUB_SECTION_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                anObjectSubSection: action.payload,
                success: true,
            };
        case AN_OBJECT_SUB_SECTION_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case AN_OBJECT_SUB_SECTION_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case AN_OBJECT_SUB_SECTION_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case AN_OBJECT_SUB_SECTION_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case AN_OBJECT_SUB_SECTION_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case AN_OBJECT_SUB_SECTION_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case AN_OBJECT_SUB_SECTION_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case AN_OBJECT_SUB_SECTION_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case AN_OBJECT_SUB_SECTION_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case AN_OBJECT_SUB_SECTION_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
